import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=62f8d241&scoped=true"
import script from "./popup.vue?vue&type=script&lang=ts"
export * from "./popup.vue?vue&type=script&lang=ts"
import style0 from "./popup.vue?vue&type=style&index=0&id=62f8d241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8d241",
  null
  
)

export default component.exports